<template>
    <div :class="$q.platform.is.mobile ? 'bg-black' : ''">
        <div class="row custom-container q-py-md">
            <div class="col-12">
                <q-input rounded outlined dense bg-color="white" color="blue-grey-4" type="search" v-model="search" :label="$t('search')" class="full-width">
                    <template v-slot:prepend>
                        <q-icon name="fal fa-search" color="blue-grey-4" />
                    </template>
                </q-input>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'SearchFaq',

    computed: {
        ...mapGetters({
            search_store: 'faq/search'
        }),

        search: {
            get() {
                return this.search_store
            },
            set(val) {
                this.$store.dispatch('faq/SET_SEARCH', [val])
            }
        }
    }
}
</script>

<style>

</style>